export default __webpack_public_path__ + "static/media/ongoing3.c9863c52.png";